import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';
import { OptionType } from 'v2/form/CustomSelectors/GeneralSelect';
import { Contact } from 'v2/models';

export const getContactNameToDisplay = ({
  first_name,
  last_name,
  primary_associations,
}: Contact) => {
  if (first_name || last_name) {
    return `${first_name || ''} ${last_name || ''}`.trim();
  } else if (primary_associations.email?.email) {
    return primary_associations.email.email;
  } else {
    return '';
  }
};

export const getContactNameToLink = (contact: Contact) => {
  return contact.first_name || contact.last_name
    ? getContactNameToDisplay(contact)
    : 'Profile';
};

export function useInternalDesignationOptions() {
  const { t } = useTranslation();

  const internalDesignationOptions: OptionType[] = [
    {
      label: `Affiliated with my ${t(TranslationKeys.company_one)}`,
      value: true,
    },
    {
      label: `Not affiliated with my ${t(TranslationKeys.company_one)}`,
      value: false,
    },
  ];

  return internalDesignationOptions;
}
